import React, {Component} from 'react';
import {Entity, Scene} from 'aframe-react';
import io from 'socket.io-client';
import {
    Grid,
    ListGroup,
    ListGroupItem,
    Col
} from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.css';

import './Watcher.css';

import macData from './macs.yml';

const LAST_ORBIT_RADIUS = 20;
const MAC_HEIGHT = 1.5;

const COLORS = [
    '#e6194b',	// Red
    '#3cb44b',	// Green
    '#ffe119',	// Yellow
    '#0082c8',	// Blue
    '#f58231',	// Orange
    '#911eb4',	// Purple
    '#46f0f0',	// Cyan
    '#f032e6',	// Magenta
    '#d2f53c',	// Lime
    '#fabebe',	// Pink
    '#008080',	// Teal
    '#e6beff',	// Lavender
    '#aa6e28',	// Brown
    '#fffac8',	// Beige
    '#800000',	// Maroon
    '#aaffc3',	// Mint
    '#808000',	// Olive
    '#ffd8b1',	// Coral
    '#000080',	// Navy
    '#808080',	// Grey
];

class Watcher extends Component {

    constructor() {

        super();

        this.socket = new io(window.location.protocol + '//' + window.location.host + '/', {
            path: '/mac/socket.io',
        });

        this.socket.emit('watch');

        this.socket.on('clients', (data) => {
            let clients = this.state.clients;
            data.forEach(c => {
                if (c !== null) {
                    c.lastPositions = [];
                    c.position = null;
                    c.latitude = null;
                    c.longitude = null;
                }
                clients.push(c);
            });
            this.setState({clients});
        });

        this.socket.on('logged-in', (data) => {
            let clients = this.state.clients;
            if (data !== null) {
                data.lastPositions = [];
                data.position = null;
                data.latitude = null;
                data.longitude = null;
            }
            clients.push(data);
            this.setState({clients});
        });

        this.socket.on('interacted', (data) => {
            let clients = this.state.clients;
            let client = clients[data.connection.id];
            if (client.lastPositions.length === 0 || Math.abs(client.lastPositions[0].x - data.data.position.x) >= 1 || Math.abs(client.lastPositions[0].z - data.data.position.z) >= 1) {
                client.lastPositions.unshift(data.data.position);
            }
            if (client.lastPositions.length > 10) {
                client.lastPositions.length = 10;
            }
            client.position = data.data.position;
            client.latitude = data.data.latitude;
            client.longitude = data.data.longitude;
            this.setState({clients});
        });

        this.socket.on('abandoned', (data) => {
            let clients = this.state.clients;
            clients[data.id] = null;
            this.setState({clients});
        });

        this.state = {
            clients: []
        };

        this.macFamilies = [];
        this.macTextures = [];
        macData.forEach(mac => {
            // Family
            let family = this.macFamilies.find(f => f.name === mac.family);
            if (!family) {
                family = {
                    name: mac.family,
                    macs: []
                };
                this.macFamilies.push(family);
            }
            let box = mac.box.split(' ').map(e => e / 100); // top bottom left right as %
            mac.offset = box[2].toFixed(4) + ' ' + box[1].toFixed(4);
            mac.height = (1 - box[0] - box[1]).toFixed(4);
            mac.width = (1 - box[2] - box[3]).toFixed(4);
            mac.repeat = mac.width + ' ' + mac.height;
            family.macs.push(mac);

            this.macTextures.push(<img key={`${mac.id}-off`} id={`${mac.id}-off`} src={`assets/off/${mac.id}.png`}
                                       alt={mac.name}></img>);
            this.macTextures.push(<img key={`${mac.id}-alpha`} id={`${mac.id}-alpha`} src={`assets/alpha/${mac.id}.jpg`}
                                       alt={mac.name}></img>);
        });
    }

    render() {

        let clientEntities = [];
        let clientList = [];

        let families = [];
        let log = [];
        const F = this.macFamilies.length;
        const GAP = LAST_ORBIT_RADIUS / F;      // gap between each family
        this.macFamilies.forEach((family, idx) => {
            let macs = [];
            let N = family.macs.length;
            const R = GAP * (idx + 1);          // radius of this orbit
            const ARC = 360 / N;                // gap between elements
            const OFFSET = 10 * idx;            // incrementing offset
            family.macs.forEach((mac, i) => {
                let angle = (i * ARC + OFFSET) * Math.PI / 180;
                let position = {
                    x: Math.sin(angle) * R,
                    y: MAC_HEIGHT,
                    z: -Math.cos(angle) * R
                };

                macs.push(<Entity key={i} position={position}>
                    <Entity primitive="a-image" alpha-map={`src: #${mac.id}-alpha`}
                            transparent material="alphaTest: 0.5" src={`#${mac.id}-off`} rotation="-90 0 0" scale="2 2 2"
                            width={mac.width} height={mac.height} offset={mac.offset} repeat={mac.repeat}></Entity>
                </Entity>);

                log.push([family.name, mac.id, mac.name, position.x.toFixed(2), position.z.toFixed(2)].join(', '));
            });
            families.push(<Entity key={`family-${idx}`}>{macs}</Entity>);
        });

        console.log(log.join('\n'));

        this.state.clients.forEach(c => {
            if (c !== null) {
                if (c.position !== null && c.latitude !== null && c.longitude !== null) {
                    let color = COLORS[c.id % COLORS.length];
                    let position = {
                        x: c.position.x,
                        y: 1,
                        z: c.position.z
                    };
                    let positionText = `${c.position.x}, ${c.position.z}`;
                    let rotation = {
                        x: -90,
                        y: -c.longitude,
                        z: 0
                    };
                    let latlon = `${c.latitude}, ${c.longitude}`;
                    let lines = {};
                    for (let i = 0; i < c.lastPositions.length - 1; i++) {
                        /*lines['line__' + i] = {
                            start: {
                                x: c.lastPositions[i].x,
                                y: 1,
                                z: c.lastPositions[i].z
                            },
                            end: {
                                x: c.lastPositions[i + 1].x,
                                y: 1,
                                z: c.lastPositions[i + 1].z
                            },
                            color: color
                        };*/
                        let p0 = c.lastPositions[i];
                        let p1 = c.lastPositions[i + 1];
                        lines['line__' + i] = `start: ${p0.x} 1 ${p0.z}; end: ${p1.x} 1 ${p1.z}; color: ${color}`;
                    }
                    clientEntities.push(<Entity key={`${c.id}-line`} {...lines}></Entity>)
                    clientEntities.push(<Entity key={c.id} primitive="a-triangle" color={color} position={position}
                                                rotation={rotation} scale="1 1.5 1"></Entity>)
                    clientList.push(<ListGroupItem key={c.id}><span style={{color}}>▶</span> #{c.id} @{positionText}
                        👁{latlon}</ListGroupItem>);
                } else {
                    clientList.push(<ListGroupItem key={c.id}>#{c.id}</ListGroupItem>);
                }
            }
        });

        return <Grid fluid className="watcher">
            <Col md={10} style={{height: '100%'}}>
                <Scene embedded>
                    <a-assets>
                        <img id="floor" src="assets/newfloor1.png" alt=""></img>
                        <img id="logos" src="assets/logos.png" alt=""></img>
                        {this.macTextures}
                    </a-assets>
                    <Entity primitive="a-plane" src="#floor" rotation="-90 180 0" scale="50 50 0" transparent></Entity>
                    <Entity primitive="a-plane" src="#logos" rotation="-90 180 0" scale="7.5 7.5 0" transparent
                            position="0 0.01 0"></Entity>
                    {families}
                    {clientEntities}
                    <Entity camera position="0 30 0" rotation="-90 0 0"></Entity>
                </Scene>
            </Col>
            <Col md={2}>
                <ListGroup>
                    {clientList}
                </ListGroup>
            </Col>
        </Grid>;
    }
}

export default Watcher;


// WEBPACK FOOTER //
// ./src/Watcher.js